import { inject, observer } from "mobx-react";
import OrderCardTypeItemView from "./OrderCardTypeItemView";
import { Order } from "views/main/types/order";

const MainBodyListTypeView = ({ rootStore }: { rootStore: any }) => {
  const { orderStore } = rootStore;
  const orderList: Order[] = orderStore.getOrderList;

  if (!orderList || orderList?.length === 0) {
    return <div className="h-[600px] bg-ui-empty" />;
  }

  return (
    <div className="card_type_content">
      <ul className="list_card">
        {orderList?.map((order, index) => (
          <OrderCardTypeItemView key={index} rootStore={rootStore} order={order}></OrderCardTypeItemView>
        ))}
      </ul>
    </div>
  );
};

export default inject("rootStore")(observer(MainBodyListTypeView));
